import React, {useEffect, useState, useRef} from "react"
import Avatar from 'components/Avatar';
import API from 'API';
import { ToggleButton } from 'react-bootstrap';
import { USER_PROFILE } from "constants/routes"
import { useHistory } from 'react-router-dom';
import Loader from '../../../../components/Loader'
import { useTranslation } from 'react-i18next';


const Members = () => {
  const [membersTotal, setMembersTotal] = useState({});  
  const [membersData, setMembersData] = useState([]);
  const [memberType, setMemberType] = useState('active');
  const [isLoading, setIsLoading] = useState(false);
  const [lastPage, setLastPage] = useState(1);
  const [page, setPage] = useState(0);
  const [isFound, setIsFound] = useState(true);

  const history = useHistory();
  const { t, i18n } = useTranslation();

  useEffect(() => {
   API.get('/user/members/totals')
   .then(resp => setMembersTotal(resp))
  }, []);
  
  useEffect(() => {
    if(lastPage === page) return;
    setIsLoading(true);
    setIsFound(false);
    API.get(`/user/members?type=${memberType}&page=${page + 1}`)
      .then(resp => {
        setMembersData([...membersData, ...resp.data])
        setLastPage(resp.meta.last_page)
      })
      .finally(() => setIsLoading(false))    
  }, [memberType, page])

  const buttonGroup = [
    { name: membersTotal?.total, value: '1', vision: t('all') },
    { name: membersTotal?.active, value: '2', vision: t('active') },
    { name: membersTotal?.expired, value: '3', vision: t('expired') },
  ];

  const observer = useRef();

  const lastPostElementRef = React.useCallback(
    node => {
      if (isLoading || lastPage === page) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(post => {
        if (post[0].isIntersecting) {
					setPage(page + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoading]
  ); 
  return(
      <div className="col members-container p-0">
        <div className='members-filter-buttons'>
          {buttonGroup.map((btn, idx) => {
            return (
            <ToggleButton
              key={idx}
              id={`radio-${idx}`}
              className="search-button-to-filter btn mr-2"
              type="radio"
              variant="secondary"
              checked={memberType === btn.vision}
              name="radio"
              value={btn.value}
              onClick={() => {
                setMemberType(btn.vision);
                if(memberType !== btn.vision) {
                  setMembersData([])
                  setPage(0)
                }
              }}
            >
              {btn.vision} {btn.name}
            </ToggleButton>
          )
          })}
        </div>  
        {membersData && membersData.length ? (
          membersData.map((item, index) => {
            return (
              <div className='d-flex members-items'
                ref={membersData.length === index + 1 ? lastPostElementRef : null}
                onClick={() => history.push(USER_PROFILE.replace(':userId?', item.user.id).replace( ':name?', item.user.nickname ? item.user.nickname : ''))}  >
                <Avatar className="members-list-avatar" size={40} image={item.user.avatar} user={item.user && item.user.name} />       
                <div className="members-list-name-wrapper">
                  <p className={'font-size-12 text-light'}> <b>{item.user.name}</b> </p>
                  <p className={'font-size-12 text-purple notifications-type'}>
                    @{item.user.nickname}
                  </p>
                </div>  
              </div>
            )
          })
         )
         :  !isFound && !isLoading ?  (
           <p className="members-not-found-text">{t("nothing_found")}</p>
         ) : null }
        <Loader className="members-loader" isLoadin={isLoading}></Loader>     
      </div>
  )
};

export default Members;